import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import { DarkModeOutlined, TodayOutlined } from "@mui/icons-material";
import { AccountCircleOutlined, Logout } from "@mui/icons-material";

import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";

import UserGreeting from "./UserGreeting";

import { baseApi } from "store/services/baseApi";
import { removeUser, selectLoggedInUser } from "../../../store/authSlice";

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const opened = Boolean(anchorEl);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const loggedInUser = useSelector(selectLoggedInUser);

  const { darkMode, toggleDarkMode } = useSidebarLayoutContext();

  // methods
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(removeUser());
    dispatch(baseApi.util.resetApiState());
    navigate("/");
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box sx={{ display: { xs: "none", sm: "flex" } }}>
        <UserGreeting />
      </Box>

      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls={opened ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={opened ? "true" : undefined}
      >
        <Avatar src={loggedInUser?.avatar?.url} sx={{ width: 32, height: 32 }}>
          {loggedInUser?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={opened}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Link to="/app/me">
          <MenuItem>
            <ListItemIcon>
              <AccountCircleOutlined fontSize="small" />
            </ListItemIcon>
            Profile
          </MenuItem>
        </Link>

        <Link to="/app/me/my-day">
          <MenuItem>
            <ListItemIcon>
              <TodayOutlined fontSize="small" />
            </ListItemIcon>
            My Day
          </MenuItem>
        </Link>

        <MenuItem>
          <ListItemIcon>
            <DarkModeOutlined />
          </ListItemIcon>
          <Switch checked={darkMode} onChange={toggleDarkMode} size="small" />
        </MenuItem>

        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
